import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../Component/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { UserContex } from "../context API/UserContext";
import edit from "./../images/pencil.png";
import delet from "./../images/delete.png";
const ManageUserProfile = ({logout}) => {
  const [users, setUsers] = useState([]);
   const [userData, setUserData] = useContext(UserContex);
   const navigate = useNavigate();
  useEffect(() => {
    axios
      .get("https://back.waratechnology.com/api/user/all")
      .then((res) => {
        setUsers(res.data.data);
      })
      .catch((err) => {
        console.log(err);
         alert(err.response.data.msg);
      });
  }, []);
  useEffect(() => {
    if (!userData.user) {
      navigate("/login");
    }
  });
  return (
    <div className="flex ">
      <Sidebar logout={logout} />
      <div className="container mx-auto p-4 ml-80">
        <h1 className="text-3xl font-bold mb-4">User Profile</h1>
        <Link
          to="/adduser"
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
        >
          Add new user
        </Link>

        <div className="mt-4 overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-200 uppercase tracking-wider border border-slate-700">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Name
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Email
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {users.map((data, index) => (
                <tr>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900 tracking-wider border border-slate-700">
                    {data.first_name + " " + data.last_name}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900 tracking-wider border border-slate-700">
                    {data.email}
                  </td>
                  <td className="px-6 py-3 text-center text-xs font-medium text-gray-900  tracking-wider border border-slate-700 ">
                    <Link
                      to={"/changepassword"}
                      className="mr-4 py-2 text-white px-3 border rounded-full bg-blue-500 hover:bg-blue-700"
                    >
                      Change Password
                    </Link>
                    <button className="px-3 py-2 text-white border rounded-full bg-blue-500 hover:bg-blue-700">
                      Forget Password
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManageUserProfile;
